/* weakKey
 *
 * Taken from https://medium.com/@antonkorzunov/an-easy-way-to-name-labels-and-generate-unique-keys-5ec2f9667e6a
 * Which was based on https://github.com/kolodny/weak-key/blob/master/index.js
 *
 * `weakKey` generates or retrieves a unique key for a given object.
 *  It's meant to be used for the `key` prop in React lists where no alternative unique identifier is available.
 */
const map = new WeakMap();
let index = 0;

/**
 * Generates or retrieves a unique key for a given object.
 *
 * @param obj {Object} The object to return a unique key for.
 * @returns {string} The unique key.
 */
export function weakKey(obj) {
  let key = map.get(obj);

  if (!key) {
    index += 1;
    key = `unique-key-${index}`;
    map.set(obj, key);
  }

  return key;
}
